import React from 'react';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap';

import { PageHeader } from '@admin/components/helpers/page_header';
import { useNavigate } from '@admin/hooks/use_navigate';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useRedirectCreateMutation, type Redirect__Input } from '@admin/schema';

import { RedirectForm } from './redirect_form';

export const RedirectNew: React.FC = () => {
  useTitle('New Redirect');
  const navigate = useNavigate();
  const [execute, { data, loading }] = useRedirectCreateMutation({ client });

  const save = async (input: Redirect__Input) => {
    if (loading) return;
    const response = await execute({ variables: { input } });
    const redirect = response?.data?.redirectCreate.redirect;
    if (!redirect) return;
    navigate(`/marketing/redirects`);
  };

  return (
    <>
      <PageHeader>
        <Breadcrumb>
          <Breadcrumb.Item>
            <NavLink to="/marketing/redirects">Redirects</NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item>New</Breadcrumb.Item>
        </Breadcrumb>
      </PageHeader>
      <RedirectForm loading={loading} error={data?.redirectCreate.error} save={save} />
    </>
  );
};
